import { useState, useRef, useEffect } from "react";
import "./VehicalCalculation.scss";
import { Box, Grid, Typography, Drawer } from "@mui/material";
import TwoWheeler from "./NewResources/1.png";
import NewTwoWheeler from "./NewResources/2.png";
import PrivateCar from "./NewResources/3.png";
import NewPrivateCar from "./NewResources/4.png";
import TaxiUpto6Passengers from "./NewResources/5.png";
import BusMoreThan6Passengers from "./NewResources/7.png";
import SchoolBus from "./NewResources/6.png";
import ThreeWheelerPCV from "./NewResources/8.png";
import GoodsCarring3Wheeler from "./NewResources/9.1.png";
import GoodsCarringMoreThan3wheeler from "./NewResources/10.png";
import Mischelleneous from "./NewResources/11.png";
import Calculations from "./Calculations";
import { PostVehicleDetails } from "../../Service/_index";
import { readStashedPrefill } from "../Policy/OnlinePolicy/utils/prefillHandoff";

const Elements = [
  {
    url: TwoWheeler,
    title: "Two Wheeler Premium",
    id: 1,
  },
  {
    url: NewTwoWheeler,
    title: "New Two Wheeler Vechicle",
    id: 2,
  },
  {
    url: PrivateCar,
    title: "Private Car",
    id: 3,
  },
  {
    url: NewPrivateCar,
    title: "New Private Car",
    id: 4,
  },
  {
    url: TaxiUpto6Passengers,
    title: "Taxi (upto 6 Passengers)",
    id: 5,
  },
  {
    url: BusMoreThan6Passengers,
    title: "Bus (More than 6 Passengers)",
    id: 6,
  },
  {
    url: SchoolBus,
    title: "School Bus",
    id: 7,
  },
  {
    url: ThreeWheelerPCV,
    title: "Three Wheeler PCV",
    id: 8,
  },
  {
    url: GoodsCarring3Wheeler,
    title: "Goods Carrying Vehicle (3 Wheeler)",
    id: 9,
  },
  {
    url: GoodsCarringMoreThan3wheeler,
    title: "Goods Carrying Vehicle (More than 3 Wheeler)",
    id: 10,
  },
  {
    url: Mischelleneous,
    title: "Miscellaneous Vehicle",
    id: 11,
  },
];

const MotorCalculation = () => {
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  console.log("eledmddents",selectedVehicle)
  const [open, setOpen] = useState(false);
  const [resultValue, setResultValue] = useState({});
  console.log("resultValue",resultValue)

  // Figures handed over from a policy's Premium Calculation dialog, if this tab
  // was opened from there. Consumed once — see utils/prefillHandoff.
  const [prefill, setPrefill] = useState(null);

  const HandleSelectVehicle = (elements) => {

    setSelectedVehicle(elements);
    setOpen(true);
  };

  /**
   * Opened from a policy's Premium Calculation dialog?
   *
   * Then skip the vehicle picker: jump straight into the calculator for the
   * vehicle type that policy quotes, with its figures already in the form. The
   * payload arrives through localStorage under the token named in ?prefill,
   * because a tab opened with window.open cannot be handed router state.
   */
  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("prefill");
    if (!token) return;

    // Drop the token from the address bar: it has been consumed, so leaving it
    // there would only invite a refresh that prefills nothing.
    window.history.replaceState({}, "", window.location.pathname);

    const payload = readStashedPrefill(token);
    if (!payload) return;

    const vehicle = Elements.find((el) => el.id === payload.formId);
    if (!vehicle) return;

    setPrefill(payload);
    setSelectedVehicle(vehicle);
    setOpen(true);
  }, []);

  const LoginUserId = sessionStorage.getItem("UserId");
  const onSubmit = (values) => {
    const data = {
      ...values,
      formId: selectedVehicle.id,
      quoteId: String(LoginUserId),
      isWebUser: true,
    };
    PostVehicleDetails(data).then((res) => {
      if (res) {
        setResultValue(res.data);
        setOpen(true);
      } else {
        // ToastError("Network Connection Error !");
      }
    });
  };

  return (
    <div className="PageContainer">
      {/* <Box sx={{ flexGrow: 1 }}>
        <Grid container className="Master_Header_Container" spacing={2}>
          <Grid item xs={12} sm={12}>
            <Typography className="Master_Header_Heading">
              Motor Calculation
            </Typography>
          </Grid>
        </Grid>
      </Box> */}

      <Grid container spacing={{ xs: 1, md: 3 }}>
        {Elements.map((el, index) => (
          <Grid item xs={12} sm={6} mb={2} md={4} key={index}>
            <Box
              className="Vehicle-Box"
              onClick={() => HandleSelectVehicle(el)}>
              <Box
                component="img"
                src={el.url}
                alt={el.title}
                sx={{
                  height:
                    el.id === 3
                      ? { xs: "100px", md: "150px", lg: "200px" }
                      : { xs: "50px", md: "80px", lg: "80px" },
                  width:
                    el.id === 3
                      ? { xs: "150px", md: "200px", lg: "250px" }
                      : { xs: "80px", md: "120px", lg: "180px" },
                }}
              />
              <Typography className="Vehicle-title">{el.title}</Typography>
            </Box>
          </Grid>
        ))}
      </Grid>

      <Drawer
        open={open}
        sx={{ zIndex: 100 }}
        anchor="right"
        PaperProps={{ sx: { width: "100%" } }}>
        {open ? (
          <Calculations
            setOpen={setOpen}
            title={selectedVehicle.title}
            selectedVehicle={selectedVehicle}
            resultValue={resultValue}
            prefill={prefill}
          />
        ) : null}
      </Drawer>
    </div>
  );
};

export default MotorCalculation;
